import React from 'react';
import { Card, CardContent, Typography, useTheme } from '@mui/material';
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar } from 'recharts';

interface PerformanceReviewProps {
  data: Array<{ name: string; value: number; color: string }>;
}

export const PerformanceReview: React.FC<PerformanceReviewProps> = ({ data }) => {
  const theme = useTheme();
  return (
    <Card sx={{ height: 400 }}>
      <CardContent>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: theme.palette.heading?.main ?? theme.palette.secondary.main }}>
          Performance Overview
        </Typography>
        <ResponsiveContainer width="100%" height={320}>
          <BarChart data={data} margin={{ top: 20, right: 20, left: 10, bottom: 100 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" tick={{ fill: theme.palette.secondary.main }} angle={-45} textAnchor="end" />
            <YAxis tick={{ fill: theme.palette.secondary.main }} />
            <Tooltip 
              contentStyle={{
                backgroundColor: theme.palette.mode === 'dark' ? '#424242' : '#ffffff',
                border: `1px solid ${theme.palette.divider}`,
                color: theme.palette.text.primary
              }}
            />
            <Bar dataKey="value" fill={theme.palette.mode === 'dark' ? '#ffffff' : '#424242'} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default PerformanceReview;


